import { getPhysicalDimensions } from '@mixtiles/web-backend-shared'
import { getCropStyle } from 'features/cart/components/ProductSummarySegment/ProductThumbnail/cropStyle'
import { getUpsellWallFrameUrl, type UpsellWall } from '../../upsellWall'
import * as S from './UpsellWallTile.styles'

type UpsellWallTileProps = {
  tileStyle: UpsellWall['tileStyle']
  photo: UpsellWall['photos'][number]
  isTurnedOff: boolean
}

export function UpsellWallTile({
  tileStyle,
  photo,
  isTurnedOff,
}: UpsellWallTileProps) {
  const { physicalWidth, physicalHeight } = getPhysicalDimensions({
    materialType: tileStyle.materialType,
    tileSize: tileStyle.tileSize,
    isPlastic: false,
  })
  const tileSizeStyle: React.CSSProperties & {
    '--tile-width-inches': number
  } = {
    '--tile-width-inches': physicalWidth,
    aspectRatio: physicalWidth / physicalHeight,
  }
  return (
    <S.Tile $isPortrait={physicalHeight > physicalWidth} style={tileSizeStyle}>
      <S.Shadow />
      <S.PhotoClip>
        <S.Photo src={photo.thumbUrl} style={getCropStyle(photo.crop)} alt="" />
        <S.TurnedOffOverlay $isTurnedOff={isTurnedOff} />
      </S.PhotoClip>
      <S.Frame
        style={{
          borderImageSource: `url(${getUpsellWallFrameUrl(tileStyle)})`,
        }}
      />
    </S.Tile>
  )
}
